import {useEffect} from "react";
import {useAuth} from "react-oidc-context";

const OidcCallback = () => {
  const auth = useAuth();

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      // Guardar el token en SessionStorage como token_TSE
      const token = auth.user.access_token;
      if (token) {
        sessionStorage.setItem("token_TSE", token);
        console.log("Token guardado en SessionStorage como token_TSE");
      }

      // Redirigir al dashboard después de la autenticación
      const returnUrl = sessionStorage.getItem("returnUrl") || "/";
      sessionStorage.removeItem("returnUrl");
      window.location.replace(returnUrl);
    }

    if (auth.error) {
      console.error("Error en el callback de OIDC:", auth.error);
      // Redirigir al login con error
      window.location.replace("/login?error=oidc_callback_failed");
    }
  }, [auth.isAuthenticated, auth.user, auth.error]);

  if (auth.isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "1rem"
        }}
      >
        <div>Procesando autenticación...</div>
        <div style={{fontSize: "0.8rem", color: "#666"}}>Espera mientras completamos tu inicio de sesión</div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "1rem"
        }}
      >
        <div>Error en la autenticación</div>
        <div style={{fontSize: "0.8rem", color: "#666"}}>{auth.error.message}</div>
        <button
          onClick={() => window.location.replace("/login")}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Volver al login
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      Completando autenticación...
    </div>
  );
};

export default OidcCallback;
